export default __webpack_public_path__ + "static/media/hm-pt-img.44e8a647.webp";